export const isDev = process.env.NODE_ENV === 'development';
export const base =
    isDev ? 'https://localhost:5000'
        : 'https://scholarshipapi.ncut.edu.tw/';
export const app_name = process.env.VUE_APP_TITLE;
export const ncut_url = 'https://www.ncut.edu.tw/index.php';

//export const SystemKey = '__替換成專屬的KEY__';
export const SystemKey = '6a511d34d8684200ae7e7e7ec689676d';
export const TOKEN_KEY = `jwt_${SystemKey}`;
export const MENU_KEY = `menu_${SystemKey}`;